import { Paper } from "@mui/material";
import { useTheme } from "@mui/system";
import DatagridComponent from "../../../../components/datagridComponent";

/**
 * Conteúdo da aba "Atendimentos" do painel direito (compartilhada entre CPE e ONU).
 * A barra de abas vive no index.js; aqui fica apenas a tabela.
 */
export default function TabAtendimentos({
	rowsAtendimentos,
	columnsAtendimentos,
	loadingAtendimentos,
}) {
	const theme = useTheme();

	return (
		<Paper
			elevation={theme.palette.mode === "dark" ? 0 : 3}
			sx={{
				width: "100%",
				height: "100%",
				overflow: "hidden",
				borderRadius: "10px",
				borderTopLeftRadius: 0,
				p: "10px",
				display: "flex",
			}}
		>
			<DatagridComponent
				title={"Atendimentos por cliente"}
				rows={rowsAtendimentos || []}
				columns={columnsAtendimentos}
				loading={loadingAtendimentos}
				sxDatagrid={{
					height: "100%",
					width: "100%",
					// Permite que o badge de OS apareça sem ser cortado pela célula.
					"& .MuiDataGrid-cell": { overflow: "visible" },
				}}
			/>
		</Paper>
	);
}
